import _extends from "@babel/runtime/helpers/extends";
import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import * as React from 'react';
import { useForkRef } from '@cian/react-utils';
import { invoke } from '../../../internal/utils/invoke';
import { DropdownPopover } from '../../../popover';
import { DateInputInput } from '../../internal/components/DateInputInput';
import { CalendarPicker } from '../../internal/components/CalendarPicker';
import { useDateLimitValue } from '../../internal/hooks';
import { useTimeout } from '../../../internal/hooks';
import { formatDateValueToHTML } from '../../internal/utils';
export var DateInputDesktop = /*#__PURE__*/React.forwardRef(function DateInputDesktop(props, ref) {
  var _React$useState = React.useState(false),
    _React$useState2 = _slicedToArray(_React$useState, 2),
    open = _React$useState2[0],
    setOpen = _React$useState2[1];
  var inputRootRef = React.useRef(null);
  var handleRef = useForkRef(ref, inputRootRef);
  var maskInputRef = React.useRef(null);
  var handleMaskInputRef = useForkRef(maskInputRef, props.maskInputRef);
  var dropdownFocusedRef = React.useRef(false);
  var min = useDateLimitValue(props.min);
  var max = useDateLimitValue(props.max);
  var inputFocusTimeout = useTimeout();
  var inputBlurTimeout = useTimeout();
  var dropdownBlurTimeout = useTimeout();
  var openDropdown = function openDropdown() {
    if (props.readOnly || props.disabled) {
      return;
    }
    setOpen(true);
  };
  var closeDropdown = function closeDropdown() {
    setOpen(false);
  };
  var handleInputClick = function handleInputClick(e) {
    invoke(props.onClick, e);
    if (!e.defaultPrevented) {
      openDropdown();
    }
  };
  var handleInputFocus = function handleInputFocus(e) {
    e.persist();
    dropdownBlurTimeout.clear();
    inputFocusTimeout.set(function () {
      var dropdownHaveFocused = dropdownFocusedRef.current;
      dropdownFocusedRef.current = false;
      openDropdown();
      if (!dropdownHaveFocused) {
        invoke(props.onFocus, e);
      }
    }, 0);
  };
  var handleInputBlur = function handleInputBlur(e) {
    e.persist();
    inputBlurTimeout.set(function () {
      if (dropdownFocusedRef.current) {
        return;
      }
      closeDropdown();
      invoke(props.onBlur, e);
    }, 0);
  };
  var handleDropdownFocused = function handleDropdownFocused(e) {
    e.preventDefault();
    dropdownFocusedRef.current = true;
    var input = maskInputRef.current;
    input === null || input === void 0 ? void 0 : input.focus();
  };
  var handleDropdownBlur = function handleDropdownBlur() {
    dropdownBlurTimeout.set(function () {
      dropdownFocusedRef.current = false;
      // Вызываем чуть позже, чтобы обработать фокус на инпуте первым
    }, 10);
  };
  var handleChange = function handleChange(nextDate) {
    if (formatDateValueToHTML(props.value) !== formatDateValueToHTML(nextDate)) {
      invoke(props.onChange, nextDate);
    }
    closeDropdown();
  };
  return /*#__PURE__*/React.createElement(DropdownPopover, {
    open: open,
    sameWidth: false,
    content: /*#__PURE__*/React.createElement("div", {
      tabIndex: 0,
      onFocus: handleDropdownFocused,
      onBlur: handleDropdownBlur
    }, /*#__PURE__*/React.createElement(CalendarPicker, {
      selected: props.value || null,
      onChange: handleChange,
      min: min,
      max: max
    }))
  }, /*#__PURE__*/React.createElement(DateInputInput, _extends({}, props, {
    ref: handleRef,
    onFocus: handleInputFocus,
    onBlur: handleInputBlur,
    onClick: handleInputClick,
    maskInputRef: handleMaskInputRef,
    min: min,
    max: max
  })));
});